"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpAddressFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const custom_types_1 = require("../../type-checking/custom-types");
const primitives_1 = require("../../type-checking/primitives");
const typing_1 = require("../../type-checking/typing");
const arrays_1 = require("../../type-checking/arrays");
class IpAddressFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, arrays_1.isArrayOfValidObjectsValue)(fieldValue, {
                country_code: (0, typing_1.Optional)(primitives_1.isStringValue),
                address: primitives_1.isStringValue,
                id: (0, typing_1.Optional)(custom_types_1.isIDValue),
            });
        };
        this.getEmptyValue = () => [];
    }
}
exports.IpAddressFieldValueGetter = IpAddressFieldValueGetter;
